import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom';
import {baseurl} from '../config/Settings';
import Header from '../partials/Header';
function Personalizeend() {

  document.body.classList.remove('personalize-tag');
  document.body.classList.add('personalize-end');

  useEffect(() => {
    if (localStorage.getItem('user-info')) {
      document.title = `Journey`;
    }

  }, []);
if (!localStorage.getItem('user-info')) {
    
      return <Navigate to="/login" />
    
  } else {
    return (
      <>
       <Header backhref="#/personalize-sections" skiphref="#/mypage" />
      <main>   
                    <div class="grid-container">
                        <div class="personal-wrap-end"> 
                            <div class="grid-x grid-margin-x align-center align-middle">
                                <div class="cell auto large-6">
                                    <div class="end-message">
                                        <div class="end-message-success">
                                            <div class="success-lottie">
                                                <lottie-player autoplay  mode="normal" src={`${baseurl}themes/custom/aawsatv3/assets/img/json/success.json?ss`} >
                                                </lottie-player>
                                            </div>
                                            <h3>تم تفعيل صفحة أخبارك بنجاح ​</h3>
                                <p>استمتع بمحتوانا المميز على منصاتك المفضلة​</p>
                                        </div>
                                        <div class="action-btn">
                                        <a href="/" className="button primary rounded next-btn">الانتقال الى الصفحة الرئيسية</a> 
                                <a href="/favoritetagspage" className="button rounded goto-btn">الانتقال إلى صفحة أخبارك</a> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                </>
    );
  }
}

export default Personalizeend;
